import React from 'react';
import { ReactComponent as ETOLogo } from './ETOLogo.svg';
import * as S from './Header.styles';

interface IHeader {
  showLegalMessage: boolean;
}

const Header = ({showLegalMessage}: IHeader) => (
    <div>
        <S.Logo>
            <ETOLogo />
        </S.Logo>
        { showLegalMessage ?
            null : 
            <S.SubHeader>
                Select an Enterprise & Site Below...
            </S.SubHeader>
        }
    </div>
);

export default Header;